import Vue from 'vue'
import Vuex from 'vuex'


// import mock from '../mock'

// let { deviceNowData, deviceBefore, deviceMessage, peoples } = mock

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 管理系统主题色
        themeColor: localStorage.getItem('themeColor') ? localStorage.getItem('themeColor') : '#1c1c24',
        // 首页地图设置
        homeMapSetting: localStorage.getItem('homeMapSetting') ? JSON.parse(localStorage.getItem('homeMapSetting')) : {
            Lng: 108.937,
            Lat: 34.27424,
            zIndex: 10,
        },
        companyId: null,
        // 大屏地图设置
        maxMapSetting: {},

        // 大屏主题色设置
        maxThemeColor: localStorage.getItem('maxThemeColor') ? localStorage.getItem('maxThemeColor') : '#15c9cb',
        // 大屏标题
        maxTitle: localStorage.getItem('maxTitle') ? localStorage.getItem('maxTitle') : '智慧城市监测系统',
        // 大屏默认标记点类型
        maxMarkerType: localStorage.getItem('maxMarkerType') ? localStorage.getItem('maxMarkerType') : 1,
        // 大屏默认样式
        maxMapStyle: localStorage.getItem('maxMapStyle') ? localStorage.getItem('maxMapStyle') : 1,


        // // 折叠菜单
        // slideMenu:[],

        // 设备目前数据
        deviceNowData: [],
        // 报警数据信息
        deviceMessage: [
        ],
        // 当前账号拥有的设备类型
        deviceTypeArr: []

    },
    getters: {
        // 获取最新设备信息
        getNewDeviceData: state => {
            return state.deviceNowData
        },
        // 获取最新报警格式化信息
        getNewDeviceMessage: state => {
            return state.deviceMessage
        },
    },
    mutations: {
        // 初始化
        initMaxMapSetting(state, value) {
            console.log(value, 'value');
            if (value == 2) {
                state.maxMapSetting = {
                    Lng: 113.23784,
                    Lat: 23.10831,
                    zIndex: 13,
                }
            } else {
                state.maxMapSetting = localStorage.getItem('maxMapSetting') ? JSON.parse(localStorage.getItem('maxMapSetting')) : (value == 2 ? {
                    Lng: 113.23784,
                    Lat: 23.10831,
                    zIndex: 13,
                } : {
                    Lng: 108.937,
                    Lat: 34.27424,
                    zIndex: 14,
                })
            }

        },
        // 修改主题颜色
        setThemeColor(state, value) {
            state.themeColor = value
        },
        // 修改首页地图显示
        setHomeMapSetting(state, value) {
            state.homeMapSetting = value
        },
        // 修改大屏地图显示
        setMaxMapSetting(state, value) {
            state.maxMapSetting = value
        },
        // 修改大屏主题颜色
        setMaxThemeColor(state, value) {
            state.maxThemeColor = value
        },
        // 修改大屏标题
        setMaxTitle(state, value) {
            state.maxTitle = value
        },
        // 修改大屏默认地图标记类型
        setMaxMarkerType(state, value) {
            state.maxMarkerType = value
        },
        // 修改大屏默认地图样式
        setMaxMapStyle(state, value) {
            state.maxMapStyle = value
        },



        // // 修改折叠菜单
        // setSlideMenu(state,value){
        //     state.slideMenu = value
        // },

        // 修改设备数据
        setDeviceNowData(state, value) {
            state.deviceNowData = value
        },
        // 动态刷新单个设备数据
        setOneDeviceData(state, value) {
            if (value.projectId == 'SDszjc') {
                console.log(value, 'value----SDszjc');

            }
            state.deviceNowData = state.deviceNowData.map(item => {
                if (item.projectId == value.projectId && item.deviceName == value.deviceName) {
                    return value
                } else {
                    return item
                }
            })

        },
        // 设置账号的设备类型
        setDeviceTypeArr(state, value) {
            state.deviceTypeArr = value
        },

        // // 修改设备过往七天数据
        // setDeviceBefore(state,value){
        //     state.deviceBefore = value
        // },
        // 增加一条报警记录
        setAlarmMessage(state, value) {
            state.deviceMessage = value
        },
        // 删除一条报警记录
        deleteAlarmMessage(state, value) {
            console.log(value);
            console.log(state.deviceMessage);
            state.deviceMessage = state.deviceMessage.filter(item => {
                return item.deviceData.deviceName != value.deviceName
            })
        },

        // 修改某个报警信息为已处理
        // setMessageSuccessOne(state, id) {
        //     state.deviceMessage.forEach((item, index) => {
        //         if (id == item.messageId) {
        //             state.deviceMessage[index].status = 1
        //         }
        //     })
        // }


        // -------------------
        // // 增加一个用户
        // addPeople(state, value) {
        //     state.peoples.push(value)
        // },
        // // 删除一个用户
        // delPeople(state, value) {
        //     let arrIndex = null
        //     state.peoples.forEach((item, index) => {
        //         if (value == item.id) {
        //             arrIndex = index
        //         }
        //     })
        //     state.peoples.splice(arrIndex, 1)
        // },
        // // 设置消息为已读
        // setNotific(state, value) {
        //     state.notific.forEach((item, index) => {
        //         if (value == item.id) {
        //             state.notific[index].status = true
        //         }
        //     })
        // },
        // // 删除消息
        // delNotific(state, value) {
        //     let arrIndex = null
        //     state.notific.forEach((item, index) => {
        //         if (value == item.id) {
        //             arrIndex = index
        //         }
        //     })
        //     state.notific.splice(arrIndex, 1)

        // },
        // // 设置整个用户自定义系统功能
        // setSetting(state, value) {
        //     state.setting = value
        // },
        // // 设置局部用户自定义
        // setSettingLocal(state, value) {
        //     switch (value.type) {
        //         case 'systemForm':
        //             state.setting = { systemForm: value.data, map: state.setting.map }
        //             break;
        //         case 'map':
        //             state.setting.map = value.data
        //             break;
        //         default:
        //             break;
        //     }
        // },

        // // 修改某个设备的状态为正常
        // setDeviceNormalOne(state, id) {
        //     state.deviceNowData.forEach((item, index) => {
        //         if (id == item.id) {
        //             state.deviceNowData[index].status = '正常'
        //         }
        //     })
        // },



    },
    actions: {
    },
    modules: {
    }
})
